/* global axios */
import ApiClient from './ApiClient';

class AccountAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  createAccount(data) {
    return axios.post(`${this.apiVersion}/accounts`, data);
  }

  async getCacheKeys() {
    const response = await axios.get(
      `/api/v1/accounts/${this.accountIdFromRoute}/cache_keys`
    );
    return response.data.cache_keys;
  }

  addPaymentMethod(accountId, data) {
    return axios.post(
      `/enterprise/api/v1/accounts/${accountId}/payment_method`,
      data
    );
  }
}

export default new AccountAPI();
